export default __webpack_public_path__ + "static/media/JimHalpert.0a784e94.jpg";